/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const Language = injectIntl(({ intl, locale }) => {
  const language = intl.formatMessage({ id: `${locale.key}.name` });
  return (
    <span>{language}</span>
  );
});
Language.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object.isRequired,
};

const LanguageOption = injectIntl(({ intl, locale, isDisabled }) => {
  const language = intl.formatMessage({ id: `${locale.key}.name` });
  return (
    <option value={locale.id} disabled={isDisabled}>{language}</option>
  );
});
LanguageOption.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};


const LanguageWithCountryCode = injectIntl(({ intl, locale }) => {
  const language = intl.formatMessage({ id: `${locale.key}.name` });
  const languageCode = intl.formatMessage({ id: `${locale.key}.code` });
  return (
    <span>{language} ({languageCode})</span>
  );
});
LanguageWithCountryCode.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object.isRequired,
};

const TranslatedLanguageWithCountryCode = injectIntl(({ intl, locale }) => {
  const language = intl.formatMessage({ id: `${locale.key}.translatedName` });
  const languageCode = intl.formatMessage({ id: `${locale.key}.code` });
  return (
    <span>{language} ({languageCode})</span>
  );
});
TranslatedLanguageWithCountryCode.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object.isRequired,
};

const LanguageWithCountryCodeOption = injectIntl(({ intl, locale, isDisabled }) => {
  const language = intl.formatMessage({ id: `${locale.key}.name` });
  const languageCode = intl.formatMessage({ id: `${locale.key}.code` });
  return (
    <option value={locale.id} disabled={isDisabled}>{language} ({languageCode})</option>
  );
});
LanguageWithCountryCodeOption.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

const TranslatedLanguageWithCountryCodeOption = injectIntl(({ intl, locale, isDisabled }) => {
  const language = intl.formatMessage({ id: `${locale.key}.translatedName` });
  const languageCode = intl.formatMessage({ id: `${locale.key}.code` });
  return (
    <option value={locale.id} disabled={isDisabled}>{language} ({languageCode})</option>
  );
});
TranslatedLanguageWithCountryCodeOption.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};


export {
  Language,
  LanguageOption,
  LanguageWithCountryCode,
  LanguageWithCountryCodeOption,
  TranslatedLanguageWithCountryCode,
  TranslatedLanguageWithCountryCodeOption,
};
